var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inited)?_c('div',{staticClass:"portal-jzlpage-container"},[_c('data-form',{attrs:{"form-id":_vm.formId,"view-id":_vm.viewId,"form-code":_vm.formCode,"view-code":_vm.viewCode,"data-id":_vm.dataId}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }